import script from "./Summary.vue?vue&type=script&setup=true&lang=js"
export * from "./Summary.vue?vue&type=script&setup=true&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=a8482710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8482710"]])

export default __exports__